 

const darkTheme={
    label:'dark',
    background:'black',
    titleColor:'dodgerblue',
    typeBoxText:'grey'
}
const greenTheme={
    label:'green',
    background:'grey',
    titleColor:'white',
    typeBoxText:'pink'
}
export const themeOptions=[
    {value:darkTheme,label:"dark"},
    {value:greenTheme,label:"green"}
]